import styled from "styled-components";

export const Container = styled.div<{variant?: string}>`
  background-color: #fff;
  border-radius: 8px;
  padding: 1rem;

  span{
    font-size: 1.6rem;
    color: #555;
  }  
`;

export const ValueText = styled.p<{variant: string}>`
  font-size: 2.2rem;
  font-weight: bold;
  margin: 0.5rem 0;
  color: ${props => props.variant === "negative" ? "#E20000" : props.variant === "positive" ? "#00B200" : "#333"};
`;